import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

export const ltoRedirectGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const router = inject(Router);
  // Only if creditType is '1' is redirected to the legacy route.
  if (route.queryParams['creditType'] === '1') {
    return router.createUrlTree(['/mx/solicitud/form/bienvenida/from-legacy'], {
      queryParams: route.queryParams
    });
  }
  // If creditType is '9' or any other, it is not redirected.
  return true;
};
